import { computable, observable } from '@chorda/core';
import { Box } from 'chorda-bulma';
import { Picsum } from '../../api';
import { Carousel, Text } from '../../helpers';
const images = observable([]);
Picsum.api.list().then(data => {
    images.$value = data;
});
export default () => {
    return Box({
        content: Carousel({
            css: 'carousel-dark',
            current: 4,
            images$: $ => computable(() => {
                return images.map(img => img.download_url);
            }),
            title: {
                templates: {
                    author: Text({
                        text$: $ => computable(() => {
                            var _a;
                            return (_a = images[$.current]) === null || _a === void 0 ? void 0 : _a.author;
                        })
                    })
                }
            }
        })
    });
};
